(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els=document.querySelectorAll('.rg-stat__num,.rg-channel-hero__stat-num,.rg-metric__num');
  if(!els.length||!('IntersectionObserver' in window))return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      io.unobserve(e.target);
      var raw=e.target.textContent.trim();
      var m=raw.match(/^([^0-9]*)(\d+(?:\.\d+)?)(.*)$/);
      if(!m)return;
      var pre=m[1],num=parseFloat(m[2]),suf=m[3],dec=(m[2].split('.')[1]||'').length;
      if(!isFinite(num)||num<=0)return;
      var t0=null,dur=1800;
      function step(ts){
        if(!t0)t0=ts;
        var p=Math.min((ts-t0)/dur,1);
        p=1-Math.pow(1-p,3);
        e.target.textContent=pre+(num*p).toFixed(dec)+suf;
        if(p<1)requestAnimationFrame(step);else e.target.textContent=raw;
      }
      requestAnimationFrame(step);
    });
  },{threshold:0.4});
  els.forEach(function(el){io.observe(el);});
})();

/* Sticky mobile CTA reveal — show after the first screen of scroll */
(function(){
  var cta = document.querySelector('[data-rg-sticky-cta]');
  if(!cta) return;
  var shown = false;
  function onScroll(){
    var past = window.scrollY > 500;
    if(past !== shown){ shown = past; cta.classList.toggle('is-visible', past); }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();

/* Gold-underline speed matcher — one visual speed for every gold bar.
   Pure CSS can't hold a single speed when links differ in length, so we set
   each link's draw duration proportional to its width (~constant px/sec).
   Two knobs: SPEED (higher = faster everywhere), and the MIND/MAXD clamp. */
(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SPEED = 120;               // px per second across every gold bar (lower = slower everywhere)
  var MIND = 0.40, MAXD = 1.2;   // clamp so nothing is jarringly quick or laggy (seconds)
  var sel = '.header__inline-menu .header__menu-item, .footer .list-menu__item.link, .footer-block__details-content a';
  function setDur(){
    var els = document.querySelectorAll(sel);
    for (var i=0; i<els.length; i++){
      var w = els[i].offsetWidth || 0;
      if(!w) continue;               // hidden elements measure as 0; re-measured when shown
      var d = Math.min(MAXD, Math.max(MIND, w / SPEED));
      els[i].style.setProperty('--rg-line-dur', d.toFixed(2) + 's');
    }
  }
  setDur();
  window.addEventListener('load', setDur);
  window.addEventListener('resize', setDur, {passive:true});
  // Dropdown children are hidden (zero width) at load, so they'd miss the match
  // and fall back to a fixed time. Re-measure them the moment a menu opens.
  var menus = document.querySelectorAll('.header__inline-menu details');
  for (var j=0; j<menus.length; j++){
    menus[j].addEventListener('toggle', function(){ if(this.open) setDur(); });
  }
})();
